var map = {
	"./1000089663.png": 855,
	"./2 (1).png": 782,
	"./Achievements - danielmututa-5357 _ Microsoft Learn.pdf": 348,
	"./CSS3.png": 264,
	"./Daniel Mutandwa Mututa CV (.1).pdf": 653,
	"./Daniel Mutandwa Mututa CV (4).pdf": 490,
	"./Daniel Mutandwa Mututa CV (8).pdf": 430,
	"./HTML5.png": 566,
	"./JAVASCRIPT.png": 717,
	"./MONGODB.png": 992,
	"./Me.jpg": 778,
	"./NODE.JS.png": 129,
	"./REACT.png": 279,
	"./astro note 13 max.png": 817,
	"./avtor.png": 154,
	"./banner-img01.jpg": 445,
	"./bootstrape.png": 183,
	"./danielmututalogo.png": 642,
	"./describe claude computing.pdf": 385,
	"./describe.pdf": 791,
	"./dimbo-p.png": 918,
	"./dimbo-puserssite-.png": 24,
	"./iphone 14 acessories.jpeg": 244,
	"./istockphoto-1894605596-612x612.jpg": 410,
	"./message-contact.jpg": 200,
	"./one.jpg": 322,
	"./phone screen set.png": 96,
	"./speedbike.jpg": 856,
	"./stylish-portfolio.jpg": 383,
	"./teaching.jpg": 41,
	"./tigzoz.jpg": 549,
	"./van-life.png": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;